import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelModal from "../modals/CancelModal";
import { Ownership } from "../../../../../apis/__generated__/graphql";

export interface CancelButtonProps {
  refetch: () => void;
  row?: Ownership;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function CancelButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: CancelButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="Delete"
        icon={
          <Tooltip title="Deny Provisional Ownership">
            <DeleteIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && (
        <CancelModal
          row={row}
          open={open}
          onClose={handleClose}
          refetch={refetch}
        />
      )}
    </>
  );
}
